import React, { useState } from "react";
import UseTable from "../../components/table/useTable";
import { useTranslation } from "react-i18next";
import globalStyles from "../../style/global.js";
import useStyles from "./productsStyle";

import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

import ErrorMessage from "../../components/errorMessage/ErrorMessage";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";
import { Avatar, Box } from "@mui/material";
import Button from "../../components/controls/Button";
import PageTitle from "../../components/pageTitle/PageTitle";
import { getProductsData } from "../../redux/reduser/products";
import AddProductDialog from "../../components/addProductDialog/AddProductDialog";
import EditProductDialog from "../../components/editProductDialog/EditProductDialog";

function Products() {
    const { t } = useTranslation();
    const classes = useStyles();
    const globalClasses = globalStyles();
    const { data, loading, error } = useSelector((state) => state.products);
    const [openAddProductDialog, setOpenAddProductDialog] = useState(false);
    const [openEditProductDialog, setOpenEditProductDialog] = useState(false);
    const [index, setIndex] = useState(null);
  
    const handleClose = () => {
      setOpenAddProductDialog(false);
    };
    const handleCloseEditAdminDialog = () => {
      setOpenEditProductDialog(false);
    };
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(getProductsData());
    }, []);
  
    const columns = [
      { name: t("id") },
      { name: t("name") },
      { name: t("price") },
    
      { name: t("description") },
      { name: t("category") },
      { name: t("image") ,
    
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <img
            height="80px"
            width="80px"
              
              src={"https://thumbs.dreamstime.com/b/no-image-available-icon-flat-vector-no-image-available-icon-flat-vector-illustration-132482930.jpg"}
              
            />
          );
        },
      },
    },
      {
        name: t(""),
        options: {
          filter: false,
          sort: false,
          customBodyRenderLite: (dataIndex) => {
            return (
              <Button
                className={classes.btn}
                color="primary"
                disabled={false}
                onClick={() => {
                 setIndex(dataIndex);
                 setOpenEditProductDialog(true);
                 
                }}
                text={t("edit")}
              />
            );
          },
        },
      },
    ];
  
    return (
      <Box className={globalClasses.background}>
      <Box className={globalClasses.page}>
      <Box className={globalClasses.row}>
       <PageTitle title={t("products")}/>
     
                 <Button
              className={classes.btn}
             
              variant="contained"
              color="primary"
              disabled={false}
              onClick={()=>{
           
                setOpenAddProductDialog(true);
              }}
              type="submit"
              text={t("addProduct")}
            />
      </Box>
      <Box >
      <AddProductDialog open={openAddProductDialog} handleClose={handleClose} close={t("close")} 
       title={ t("addProduct")}  
      />
       <EditProductDialog open={openEditProductDialog} handleClose={handleCloseEditAdminDialog} close={t("close")} 
     title={ data!=[] && index!=null?data[index][1]:""}  data={data!=[]?data[index]:""}
      />
        {loading === true ? (
          <div className={globalClasses.center}>
            {" "}
            <CircularProgressBar />{" "}
          </div>
        ) : error == null ? (
          <UseTable
            data={data}
            columns={columns}
            title={t("products")}
            selectableRows={true}
          />
        ) : (
          <div className={globalClasses.center}>
            {" "}
            <ErrorMessage title={error} />{" "}
          </div>
        )}
      </Box>
      
      </Box>
      </Box>
    );
  }
export default Products
